<template>
	<div id="trainRecords">
			<div id="container"></div>
			<ul class="records first">
				<li>
          <div class="content">
  					<p>
              <span v-if="!!cardStatistics.totalVideoLearnDuration && (cardStatistics.totalVideoLearnDuration/60) < 1">1</span>
              <span v-else>
                {{ !!cardStatistics.totalVideoLearnDuration ? (cardStatistics.totalVideoLearnDuration/60).toFixed(0) : 0 }}
              </span>
              分钟
            </p>
  					<p>课程听取</p>
          </div>
				</li>
				<li>
          <div class="content">
  					<p><span>{{ !!cardStatistics.totalPracticeCount ? cardStatistics.totalPracticeCount : 0 }}</span>次</p>
  					<p>练习次数</p>
          </div>
				</li>
			</ul>
			<ul class="records">
				<li>
          <div class="content">
  					<p><span>{{ !!cardStatistics.totalExamCount ? cardStatistics.totalExamCount : 0 }}</span>次</p>
  					<p>考试次数</p>
          </div>
				</li>
				<li>
          <div class="content">
  					<p><span>{{ !!cardStatistics.accumulativeLearnDays ? cardStatistics.accumulativeLearnDays : 0 }}</span>天</p>
  					<p>学习天数</p>
          </div>
				</li>
			</ul>
		</div>
</template>

<script>
  import "../../static/train.less"
  import Highcharts from "../../static/highcharts.js"
  import "../../static/exporting.js"

  export default {
    data() {
      return {
        'token': this.$route.query.tjkapptoken,
        'list': [], //图表数据
        'cardStatistics': {}, //列表数据
        'xlist': [],
        'ylist': [],
        'time': ''
      }
    },
    mounted: function () {
      this.init()
    },
    methods: {
      init() {
        document.cookie = 'login_token='+ this.token + ';'
        this.$http.post(API_ROOT.college + '/tjkMajorStatistics/queryMyStatistics').then(response => {
          var result = response.data
          this.success = result.success
          this.message = result.msg
          if (result.success) {
            this.list = result.data.recentTjkMajorStatistics
            this.cardStatistics = result.data.tjkCourseStatistics
            this.time = (result.data.totalLearningDuration/3600).toFixed(2)
            for(var i=0;i<this.list.length;i++) {
                var dataDate = new Date(this.list[i].collectDate)
              this.xlist.push((dataDate.getMonth() + 1) + '/' + dataDate.getDate())
              this.ylist.push(parseInt((this.list[i].totalLearningDurationPerDay/60).toFixed(0)))
            }
            this.initCharts()
            document.cookie = 'login_token='+ this.token + ';expires='+ new Date(0).toGMTString()
          }else {
            alert(result.msg)
            document.cookie = 'login_token='+ this.token + ';expires='+ new Date(0).toGMTString()
          }
        }, response => {
          alert('网络繁忙，请稍后重试！')
        })
      },
      initCharts() {
        var chart = Highcharts.chart('container', {
			chart: {
				type: 'areaspline',
                height:300
			},
			title: {
			  	text: '学习总时长:'+this.time+'小时',
			  	style:{
					color:'#2A2A2A',
					fontSize:'18px'
			  	}
			},
            tooltip:{
                enabled:false
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false // 禁用版权信息
            },
            navigation:{
                buttonOptions:{
                    enabled:false
                }
            },
            plotOptions: {
                areaspline: {
                    dataLabels:{
                        enabled:true,
                        format:'{y} 分钟',
                        style:{
                            color:'#2A2A2A',
                            textOutline:"none"
                        }
                    },
                    fillColor: {
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1
                        },
                        stops: [
                            [0, '#B4D0FF'],
                            [1, '#fff']
                        ]
                    },
                    marker: {
                        symbol:'circle',
                        fillColor:'#ffffff',
                        lineColor:'#77A9FD',
                        lineWidth:2,
                        radius: 5
                    },
                    lineWidth: 2,
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    },
                    threshold: null
                }
            },
            xAxis: {
                categories: this.xlist,
                lineWidth:0,
                tickLength:0
            },
            yAxis: {
                visible:false
            },
            series: [{
                name: '学习时长',
                data: this.ylist
            }]
        })
      }
    }
  }
</script>

<style type="less" scoped>
  .highcharts-legend-box {
    display: none !important;
  }
  .highcharts-credits {
    display: none !important;
  }
</style>


// WEBPACK FOOTER //
// ./src/page/trainRecords.vue